export default {
    setCurrentSite(context,payload) {
        context.commit('setCurrentSite',payload)
    },
    setSites(context,payload) {
        context.commit('setSites',payload);
    }
}